var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import { Button, IconButton } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classnames from 'classnames';
import * as React from 'react';
import { useBreakpointValue } from 'utils/mediaQuery';
import styles from './header.module.scss';
export const Header = (_a) => {
    var { children, className, iconsList, title, isOpen, isFavorite, avatar, small, canCall, onCallClick, onEditClick, onFavoriteClick, onToggle, status, onPhone, simultaneous, actions } = _a, otherProps = __rest(_a, ["children", "className", "iconsList", "title", "isOpen", "isFavorite", "avatar", "small", "canCall", "onCallClick", "onEditClick", "onFavoriteClick", "onToggle", "status", "onPhone", "simultaneous", "actions"]);
    const isSmallScreen = useBreakpointValue({ base: true, lg: false });
    const rootClass = classnames({
        [styles.headerTeam]: true,
        [styles.headerTeamOpen]: isOpen,
    }, className);
    const avatarClasses = classnames({
        [styles.avatarWrap]: true,
        [styles.avatarSmall]: small,
    }, className);
    const iconsClass = classnames({
        [styles.icons]: canCall !== true,
        [styles.iconsCall]: canCall === true,
    }, className);
    const statusClass = classnames({
        [styles.status]: !onPhone && !simultaneous,
        [styles.statusActive]: status === 'working',
        [styles.statusAway]: status === 'away',
        [styles.statusOffline]: status === 'offline',
    }, className);
    const iconChannelClass = classnames({
        [styles.statusIcon]: onPhone || simultaneous,
        [styles.statusIconActive]: status === 'working',
        [styles.statusIconAway]: status === 'away',
        [styles.statusIconOffline]: status === 'offline',
    }, className);
    let iconChannel = '';
    if (onPhone === true) {
        iconChannel = 'phone-bold';
    }
    else if (simultaneous === true) {
        iconChannel = 'simultaneous-bold';
    }
    const handleFavoriteToggle = (event) => {
        event.stopPropagation();
        onFavoriteClick === null || onFavoriteClick === void 0 ? void 0 : onFavoriteClick();
    };
    return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass, onClick: () => onToggle(!isOpen), 
        // prevent selection of contents if doubleclicking
        onMouseDown: (event) => event.preventDefault() }, { children: [_jsxs("div", Object.assign({ className: styles.headerPerson }, { children: [isFavorite !== undefined && (_jsx(IconButton, { className: styles.favoriteIcon, variant: "tertiary", icon: isFavorite ? 'star-full' : 'star', iconProps: {
                            color: isFavorite ? colors.orange[300] : colors.neutral[400],
                        }, onClick: handleFavoriteToggle })), !!avatar && _jsx("div", Object.assign({ className: avatarClasses }, { children: avatar })), (status === 'away' || status === 'working' || status === 'offline') &&
                        !onPhone &&
                        !simultaneous && _jsx("div", { className: statusClass }), (onPhone || simultaneous) && (_jsx(DixaIcon, { icon: iconChannel, className: iconChannelClass })), _jsx("h2", Object.assign({ onMouseDown: (event) => event.stopPropagation(), className: styles.title }, { children: children }))] })), _jsxs("div", Object.assign({ className: styles.pullRight }, { children: [!isSmallScreen || !iconsList ? (_jsx("div", Object.assign({ className: iconsClass }, { children: iconsList }))) : null, !!canCall && (_jsx(Button, Object.assign({ variant: "secondary", className: styles.teamCardButton, onClick: onCallClick }, { children: "Call" }))), onEditClick && (_jsx(Button, Object.assign({ variant: "secondary", className: styles.teamCardButton, onClick: onEditClick }, { children: "Edit" }))), actions, _jsx(DixaIcon, { icon: "angle-right", className: styles.arrow, onClick: onToggle })] }))] })));
};
Header.displayName = 'Header';
